import { CallStatus } from '@numeo/types'

interface GetStylesParams {
    dispatcherRequestAlert: boolean
    rateHighlight: boolean
}
export const getStyles = ({ dispatcherRequestAlert, rateHighlight }: GetStylesParams) => {
    if (dispatcherRequestAlert) {
        return {
            backgroundColor: 'warning.50',
            borderColor: 'warning.300',
        }
    } else if (rateHighlight) {
        return {
            backgroundColor: 'success.50',
            borderColor: 'success.300',
        }
    }
    return {
        backgroundColor: 'background.surface',
        borderColor: 'divider',
    }
}

export const getStatusColor = (callStatus?: CallStatus) => {
    switch (callStatus) {
        case CallStatus.CONNECTED:
            return 'success.500'
        case CallStatus.INITIATING:
            return 'primary.500'
        case CallStatus.ENDED:
        case CallStatus.BUSY:
            return 'warning.500'
        case CallStatus.ERROR:
            return 'danger.500'
        default:
            return 'neutral.500'
    }
}

export const maximizedUIAnimationStyles = {
    position: 'fixed',
    right: 0,
    top: 0,
    bottom: 0,
    width: '600px',
    bgcolor: 'background.surface',
    borderLeft: '1px solid',
    boxShadow: 'sm',
    borderColor: 'divider',
    p: 2,
    zIndex: 1000,
    overflowY: 'auto',
    transformOrigin: 'bottom right',
    '@keyframes expandFromBottom': {
        from: {
            transform: 'translateY(calc(100vh - 160px))',
            borderRadius: 'md',
            width: '450px',
            right: '20px',
        },
        to: {
            transform: 'translateY(0)',
            borderRadius: '0',
            width: '600px',
            right: '0',
        },
    },
    '@keyframes collapseToBottom': {
        from: {
            transform: 'translateY(0)',
            borderRadius: '0',
            width: '600px',
            right: '0',
        },
        to: {
            transform: 'translateY(calc(100vh - 160px))',
            borderRadius: 'md',
            width: '450px',
            right: '20px',
            opacity: 0,
        },
    },
}

export const getMaximizedCallOverlayAnimationStyles = (isMinimizing: boolean) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 999,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    opacity: isMinimizing ? 0 : 1,
    transition: 'opacity 0.25s ease-in-out',
    backdropFilter: isMinimizing ? 'blur(0px)' : 'blur(1px)',
})
